module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEPSURBVEiJtdQxisJQEAbgfxIvoNZ6hi3iAbyBEgvbJc0Wokkn2KRZLI0HeFhqEVf2BDmAzd7B2ngBYSwUFFchM3mZ6r15b/gYGAYQxsik3siknrTOkXwem/TLBe1d0H5ifuaVQQSa3W88nZjtohKIwb9PqbAoJoIah2YI8FaDkQQCgDjOaqfWcQOQ//SULAM/sgZpMRWkwdSQFCsFSbDSUFFMNN7voe65fmgOX4/+dYNY6egOvu7MAXesdPQYDOJ/Occ9W4PiOKvlrXxNwOAxT0CUfPb/rA3DWyTwk9u5eqQ0VBQpBUkQNSRFVJAGEUNaBBCuoFM7X2gQMQRGT4OIIQZ/axBVRCb1wtXuQ1p3AdiEnvm6LfbKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/m1.png
// module id = CHhE
// module chunks = 1